import { FormQuestionValue } from '../../../../../../types/Forms'

export const checkHasAnyAnswer = (answer: FormQuestionValue | null | undefined) => !!answer && !!answer.value

export default checkHasAnyAnswer
